import { env } from "@/config";

export function trackNetworxPage(
  pageName: string,
  props?: Record<string, unknown>
) {
  const trackingId = typeof window.tracking_id !== "undefined" ? window.tracking_id : "";
  if (env.isDev) {
    console.log(
      "nxTracker.trackQuotes",
      location.href,
      pageName,
      undefined,
      trackingId,
      undefined,
      props
    );
  }
  window.nxTracker?.trackQuotes(
    location.href,
    pageName,
    undefined,
    trackingId,
    undefined,
    props
  );
}

declare global {
  interface Window {
    tracking_id?: string;
    nxTracker?: {
      trackQuotes: (
        uri: string,
        page_type: string,
        num_questions?: number,
        tracking_id?: string,
        page_view_params?: Record<string, unknown>,
        more_props?: Record<string, unknown>
      ) => void;
      track: (uri: string, page_type: string, params?: string) => void;
    };
  }
}
